import { IApiError } from '@/models/apiError.model';
import { IFaqChannel } from '@/models/faqChannel.model';

export const SLICE_NAME = 'faqChannels';

export interface FaqChannelsState {
  channels: IFaqChannel[] | null;
  isLoading: boolean;
  error: IApiError | null;
}

export const initialState: FaqChannelsState = {
  channels: null,
  isLoading: false,
  error: null,
};
